import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  title,
  description,
  action,
  hover = false
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-gray-200 shadow-soft ${hover ? 'card-hover' : ''} ${className}`} data-id="element-97">
      {(title || action) && <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-start gap-4" data-id="element-98">
          <div className="min-w-0 flex-1" data-id="element-99">
            {title && <h3 className="text-lg font-semibold text-gray-900 truncate" data-id="element-100">
                {title}
              </h3>}
            {description && <p className="text-sm text-gray-500 mt-1 line-clamp-2" data-id="element-101">
                {description}
              </p>}
          </div>
          {action && <div className="flex-shrink-0" data-id="element-102">{action}</div>}
        </div>}
      <div className="p-6" data-id="element-103">{children}</div>
    </div>;
}